import { render, staticRenderFns } from "./clientStatusIcon.vue?vue&type=template&id=1dd6adc6"
import script from "./clientStatusIcon.vue?vue&type=script&lang=js"
export * from "./clientStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports